import React, { useEffect } from "react";
import styles from "./Home.module.css";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import axios from "axios";
const Home = () => {
  
  const history = useHistory();
  useEffect(() => {
    const sendDeviceIdToServer = async (deviceId) => {
      try {
        if (!deviceId) return { ok: false, reason: "missing_device_id" };
        localStorage.setItem("currentDeviceId", deviceId);
        window.__CURRENT_DEVICE_ID__ = deviceId;
        const profile = JSON.parse(localStorage.getItem("profile") || "null");
        const userId = profile?.result?._id;
        const token = profile?.token;
        if (!userId || !token) {
          localStorage.setItem("pendingDeviceId", deviceId);
          return { ok: false, reason: "not_authenticated" };
        }
        await axios.post(
          `${process.env.REACT_APP_API}/users/deviceId/${userId}`,
          { deviceId },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        localStorage.removeItem("pendingDeviceId");
        return { ok: true };
      } catch (error) {
        console.error("Failed to save deviceId:", error);
        return { ok: false, reason: "request_failed" };
      }
    };

    // Expose to Flutter WebView: window.setDeviceId("FCM_TOKEN")
    window.setDeviceId = async (deviceId) => {
      const result = await sendDeviceIdToServer(deviceId);
      try {
        if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({ type: "deviceIdResult", ...result })
          );
        }
      } catch (e) {
        // ignore
      }
      return result;
    };

    return () => {
      if (window.setDeviceId) {
        delete window.setDeviceId;
      }
      if (window.__CURRENT_DEVICE_ID__) {
        delete window.__CURRENT_DEVICE_ID__;
      }
    };
  }, []);

 
  return (
    // <div className={styles.pageContainer}>
      <section className={styles.hero}>
        <h1>Sadhana Ayurvedics Pvt. Ltd </h1>
        <div className={styles.wrap}>
          <button  onClick={() => history.push("/login")} className={styles.login}> Get started</button>
          {/* <button  onClick={handleSendNotification} className={styles.login}>Push Notification</button> */}
        </div>
      </section>
    // </div>
  );
};

export default Home;
